import { Injectable } from '@angular/core';
import { Resolve} from '@angular/router';

import { LayerService, AppLayer } from './layer.service';

@Injectable()
export class ResolverLayersService implements Resolve<AppLayer[]> {

	constructor(
		private layerService: LayerService
	) { }

	async resolve(): Promise<AppLayer[]> {
		//
		const layers = await this.layerService.getLayers();
		// resolve bdry layers too
		await this.layerService.getBdryLayers();

		return layers;
	}

}
